import FileSaver from 'file-saver'
import { REGIONS } from '../../utils/constants'
import { sortObjectsArray } from '../../utils/functions/common'
import { setBold } from './common'
import {
  addHeaderRow,
  addTableHeader,
  addTableRow,
  addTableTotalRow,
  getUnlockedCellsForRow,
  setColumnsWidth,
} from './commonStatementFunctions'

const Excel = require('exceljs')

export default async function (supplier, period) {
  const columns = supplier.agreement.columns || []
  const columnsCount = columns.length || 2

  const workbook = new Excel.Workbook()
  const worksheet = workbook.addWorksheet('SYNTHESE', { views: [{ showGridLines: false }] })
  setColumnsWidth(worksheet, columnsCount)

  let row = 1
  addHeaderRow(worksheet, row, columnsCount)
  worksheet.getCell('A1').value = period
  addTableHeader(worksheet, row + 1, columns)

  const coopGroups = sortObjectsArray(supplier.agreement.coopGroups, 'name')
  const emptyAmounts = Array(REGIONS.length).fill(0)
  coopGroups.forEach((coopGroup, index) => {
    row = 3 + index
    addTableRow(worksheet, coopGroup, emptyAmounts, row, columns)
  })

  row++
  addTableTotalRow(worksheet, 1, row, columns)

  worksheet.addRow()
  worksheet.addRow()
  worksheet.addRow()
  worksheet.addRow()
  worksheet.addRow()
  row = row + 6

  worksheet.addRow(['Lexique :'])
  setBold(worksheet, row)
  REGIONS.map((region) => {
    worksheet.addRow([region.code, region.name])
  })

  await worksheet.protect('MNWx7t56aT5M')
  for (let i = 3; i < supplier.agreement.coopGroups.length + 3; i++) {
    const unlockedCells = getUnlockedCellsForRow(i, columnsCount)
    unlockedCells.forEach((cell) => {
      worksheet.getCell(cell).protection = { locked: false }
    })
  }

  const buffer = await workbook.xlsx.writeBuffer()
  FileSaver.saveAs(new Blob([buffer]), `Declaration ${supplier.name} ${period} vierge.xlsx`)
}
